(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-promo-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dual-promo-fade-slider')) {
    class DualPromoFadeSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.dual-promo-slider__viewport');
        this.slides = Array.from(this.querySelectorAll('.dual-promo-slider__slide'));
        this.currentIndex = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        if (this.currentIndex === -1) this.currentIndex = 0;

        this.speed = Number(this.dataset.speed || 5) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.slides.forEach((slide) => this.resizeObserver.observe(slide));

        this.activateSlide(this.currentIndex);

        this.handleMouseEnter = () => this.pause();
        this.handleMouseLeave = () => this.play();
        this.handleFocusIn = () => this.pause();
        this.handleFocusOut = (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.play();
        };
        this.handleBlockSelect = (event) => {
          const targetSlide = event.target.closest('.dual-promo-slider__slide');
          if (!targetSlide || !this.contains(targetSlide)) return;
          this.pause();
          this.activateSlide(this.slides.indexOf(targetSlide));
        };
        this.handleBlockDeselect = (event) => {
          if (!this.contains(event.target)) return;
          this.play();
        };

        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        if (this.slides.length > 1 && !this.reducedMotion.matches) {
          this.play();
        }
      }

      disconnectedCallback() {
        this.pause();
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      play() {
        if (this.slides.length < 2 || this.reducedMotion.matches) return;
        this.viewport.setAttribute('aria-live', 'off');
        this.pause();
        this.timer = window.setInterval(() => {
          this.activateSlide((this.currentIndex + 1) % this.slides.length);
        }, this.speed);
      }

      pause() {
        this.viewport.setAttribute('aria-live', 'polite');
        if (this.timer) window.clearInterval(this.timer);
      }

      activateSlide(index) {
        if (!this.slides[index]) return;

        this.currentIndex = index;
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          slide.querySelectorAll('a').forEach((link) => {
            if (isActive) {
              link.removeAttribute('tabindex');
            } else {
              link.setAttribute('tabindex', '-1');
            }
          });
        });

        this.updateHeight();
      }

      updateHeight() {
        if (!this.viewport || !this.slides[this.currentIndex]) return;
        this.viewport.style.height = `${this.slides[this.currentIndex].offsetHeight}px`;
      }
    }

    customElements.define('dual-promo-fade-slider', DualPromoFadeSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
